var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2013_41476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9283 1.60882H8.67829V0.751674C8.67829 0.692746 8.63008 0.644531 8.57115 0.644531H7.82115C7.76222 0.644531 7.71401 0.692746 7.71401 0.751674V1.60882H4.28544V0.751674C4.28544 0.692746 4.23722 0.644531 4.17829 0.644531H3.42829C3.36936 0.644531 3.32115 0.692746 3.32115 0.751674V1.60882H1.07115C0.834096 1.60882 0.642578 1.80033 0.642578 2.03739V10.9302C0.642578 11.1673 0.834096 11.3588 1.07115 11.3588H10.9283C11.1653 11.3588 11.3569 11.1673 11.3569 10.9302V2.03739C11.3569 1.80033 11.1653 1.60882 10.9283 1.60882ZM10.3926 10.3945H1.60686V5.30525H10.3926V10.3945ZM1.60686 4.39453V2.5731H3.32115V3.21596C3.32115 3.27489 3.36936 3.3231 3.42829 3.3231H4.17829C4.23722 3.3231 4.28544 3.27489 4.28544 3.21596V2.5731H7.71401V3.21596C7.71401 3.27489 7.76222 3.3231 7.82115 3.3231H8.57115C8.63008 3.3231 8.67829 3.27489 8.67829 3.21596V2.5731H10.3926V4.39453H1.60686Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2013_41476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.aff5fec5f0d1bb4ce2895f6d05b78dba.svg";
export { ForwardRef as ReactComponent };